export default "__VITE_ASSET__CwhUjPvo__"